import firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    skype: null,
    consultation: null,
    threeDays: null
  },
  mutations: {
    setSkype(state, payload) {
      state.skype = payload
    },
    setConsultations(state, payload) {
      state.consultation = payload
    },
    setThreeDays(state, payload) {
      state.threeDays = payload
    }
  },
  actions: {
    async skypeConsultation({commit, state}, {price1, time1, price2, time2}) {
      try {
        await firebase.database().ref('database/price/main').child(state.skype.id).update({
          price1,
          time1,
          price2,
          time2
        })
        commit('setSkype', {id: state.skype.id, price1, time1, price2, time2})
      } catch (e) {
        throw e
      }
    },
    async chatConsultation({commit, state}, price) {
      try {
        await firebase.database().ref('database/price/chat').child(state.consultation.id).update({
          price: price,
        })
        commit('setConsultations', {id: state.consultation.id,  price})
      } catch (e) {
        throw e
      }
    },
    async threeDaysConsultation({commit, state}, price) {
      try {
        await firebase.database().ref('database/price/threeDaysChat').child(state.threeDays.id).update({
          price: price
        })
        commit('setThreeDays', {id: state.threeDays.id, price})
      } catch (e) {
        throw e
      }
    },
    async fetchSkypeConsultation({commit}) {
      try {
        const requests = (await firebase.database().ref(`database/price/main`).once('value')).val() || {}
        let response  =  Object.keys(requests).map(key => ({...requests[key], id: key}))
        response = response[0]
        commit('setSkype', response)
      } catch (e) {
        throw e
      }
    },
    async fetchChatConsultation({commit}) {
      try {
        const requests = (await firebase.database().ref(`database/price/chat`).once('value')).val() || {}
        let response  =  Object.keys(requests).map(key => ({...requests[key], id: key}))
        response = response[0]
        commit('setConsultations', response)
      } catch (e) {
        throw e
      }
    },
    async fetchThreeDaysConsultation({commit}) {
      try {
        const requests = (await firebase.database().ref(`database/price/threeDaysChat`).once('value')).val() || {}
        let response =  Object.keys(requests).map(key => ({...requests[key], id: key}))
        response = response[0]
        commit('setThreeDays', response)
      } catch (e) {
        throw e
      }
    },
  }
}